import { render, staticRenderFns } from "./BottomBarHidden.vue?vue&type=template&id=afa1288a&"
import script from "./BottomBarHidden.vue?vue&type=script&lang=js&"
export * from "./BottomBarHidden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports